import { create } from 'zustand';

interface DUMP {
  dump: number;
  setDump: () => void;
}

export const useDUMP = create<DUMP>()((set) => ({
  dump: 0,
  setDump: () => set((state) => ({ dump: state.dump + 1 }))
}));
